import m from "../../geodata/es2015/channelIslandsLow";
window.am4geodata_channelIslandsLow = m;


//////////////////
// WEBPACK FOOTER
// ./geodata/channelIslandsLow.js
// module id = null
// module chunks = 